// extracted by mini-css-extract-plugin
export default {"table_wrapper":"Monitoring_table_wrapper__Ei3OW","header_container":"Monitoring_header_container__Hlf0a"};